import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveFilter as _resolveFilter, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "plans-grid"
};
const _hoisted_2 = {
  key: 0,
  class: "plan-badge"
};
const _hoisted_3 = {
  class: "plan-header"
};
const _hoisted_4 = {
  class: "plan-price-line"
};
const _hoisted_5 = {
  class: "plan-price"
};
const _hoisted_6 = {
  class: "plan-period"
};
const _hoisted_7 = {
  class: "plan-body"
};
const _hoisted_8 = {
  key: 0,
  class: "plan-note"
};
const _hoisted_9 = {
  class: "plan-description"
};
const _hoisted_10 = {
  class: "plan-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _filter_billingType = _resolveFilter("billingType");
  return $props.types && $props.types.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sortedTypes, type => {
    return _openBlock(), _createElementBlock("div", {
      key: type.id,
      class: _normalizeClass(["plan-card", {
        recommended: $options.bestValueId === type.id && $options.sortedTypes.length > 1
      }])
    }, [$options.bestValueId === type.id && $options.sortedTypes.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Best Value ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("h3", null, _toDisplayString(type.name), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(type.localcurrencyformatted), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_filter_billingType(type.duration)), 1)])]), _createElementVNode("div", _hoisted_7, [type.localcurrency !== 'USD' ? (_openBlock(), _createElementBlock("div", _hoisted_8, " * Charges will be made in USD @ $" + _toDisplayString(type.amount) + ", international fees may apply ", 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_9, _toDisplayString(type.longdescription), 1)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_router_link, {
      class: _normalizeClass(["plan-select-btn", {
        primary: $options.bestValueId === type.id && $options.sortedTypes.length > 1
      }]),
      to: '/subscribe/' + type.id
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" Select Plan ", -1)]))], undefined, true),
      _: 1
    }, 8, ["class", "to"])])], 2);
  }), 128))])) : _createCommentVNode("", true);
}